import Tabs from '@mui/material/Tabs';
import { useStylesTabs } from './styles';

function StageHeaderTabs(props) {
    const classes = useStylesTabs();
    return (
        <Tabs
            {...props}
            className={[classes.root, classes.scrollButtons, classes.tabList].join(' ')}
            scrollButtons="auto"
            variant="scrollable"
            indicatorColor="secondary"
            aria-label="Tabbar"
        >
            {props.children}
        </Tabs>
    );
}

export default StageHeaderTabs;
